import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import LogoImage from "../assets/logo.png";
import Clg_LogoImage from "../assets/sponsors_img/arya_logo.jpg";
import ubuy_LogoImg from "../assets/sponsors_img/Ubuy_HD_logo.jpg"
import "../styles/global.css";

const Navbar = ({
  heroRef,
  aboutRef,
  contactRef,
  faqsRef,
  judgesRef,
  prizeRef,
  problemRef,
  sponsorsRef,
  timelineRef,
  trackRef,
}) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (ref) => {
    setMenuOpen(false);
    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <nav>
        <a href="/"><img className="logo" alt="This is logo of Innovastra" src={LogoImage}></img></a>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <div className="nav-link-div">
            <li><a className="nav_buttons" href="/">Home</a></li>
            <li><a className="nav_buttons" href="/problem-statements">Problems</a></li>
            <li><a className="nav_buttons" href="/guide">Guide</a></li>
            <li><a className="nav_buttons" href="/support">Support</a></li>
            <li><a className="nav_buttons" href="/Ourteam">Our Team</a></li>
          </div>
          <div className="reg-div">
            <a className="cert-button" href="/certificates"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg> Certificates</a>
          </div>
        </div>
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
